import { c as _c } from "react/compiler-runtime";
import { AFFILIATE_DASHBOARD_API } from 'modules/affiliate-dashboard/api/affiliate-dashboard-api';
import { AffiliateDashboardFilterWithTagInterface } from 'modules/affiliate-dashboard/types/affiliate-dashboard-interface';
import { AffiliateDashboardPaymentsApiInterface } from 'modules/affiliate-dashboard/types/affiliate-dashboard-payments-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { CountInterface, SwrPaginationInterface } from 'shared/types/pagination-interface';
import { getFilterQueryString } from 'shared/utils/api/get-filter-query-string';
import { getPaginationAndFilterQueryString } from 'shared/utils/api/get-pagination-and-filter-query-string';
import { baseFetcher } from 'shared/utils/http-client';
import useSWR from 'swr';
import { useControlledSwr } from '@systemeio/util';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
interface UseAffiliateDashboardPaymentsInterface extends SwrPaginationInterface {
  filter: AffiliateDashboardFilterWithTagInterface;
}
export const useAffiliateDashboardPayments = t0 => {
  const $ = _c(20);
  const {
    filter,
    limit,
    pagination
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  let t2;
  if ($[1] !== filter.affiliateTag || $[2] !== filter.dateSince || $[3] !== filter.dateTill) {
    t2 = {
      affiliateTag: filter.affiliateTag,
      dateTill: filter.dateTill,
      dateSince: filter.dateSince
    };
    $[1] = filter.affiliateTag;
    $[2] = filter.dateSince;
    $[3] = filter.dateTill;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const paymentsFilter = t2;
  let t3;
  if ($[5] !== filter.dateSince || $[6] !== filter.vendorId || $[7] !== limit || $[8] !== pagination || $[9] !== paymentsFilter || $[10] !== user) {
    t3 = () => {
      if (!user || filter.dateSince === null) {
        return;
      }
      return [`${AFFILIATE_DASHBOARD_API}/payments/list${filter.vendorId ? `/${filter.vendorId}` : ""}?${getPaginationAndFilterQueryString({
        limit,
        pagination,
        filter: paymentsFilter
      })}`, RequestModuleEnum.Contacts];
    };
    $[5] = filter.dateSince;
    $[6] = filter.vendorId;
    $[7] = limit;
    $[8] = pagination;
    $[9] = paymentsFilter;
    $[10] = user;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const {
    data: affiliatePayments
  } = useControlledSwr(t3, fetcher);
  let t4;
  if ($[12] !== filter.dateSince || $[13] !== filter.vendorId || $[14] !== paymentsFilter || $[15] !== user) {
    t4 = () => {
      if (!user || filter.dateSince === null) {
        return;
      }
      return `${AFFILIATE_DASHBOARD_API}/payments/count${filter.vendorId ? `/${filter.vendorId}` : ""}?${getFilterQueryString({
        filter: paymentsFilter
      })}`;
    };
    $[12] = filter.dateSince;
    $[13] = filter.vendorId;
    $[14] = paymentsFilter;
    $[15] = user;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  const {
    data: counter
  } = useSWR(t4, baseFetcher);
  let t5;
  if ($[17] !== affiliatePayments || $[18] !== counter) {
    t5 = {
      affiliatePayments,
      counter
    };
    $[17] = affiliatePayments;
    $[18] = counter;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  return t5;
};